/** @file       form.css
 *  @author     Alex Huctwith <alex@kingsds.network>
 *  @author     Kevin Yu <kevin@distributive.network>
 *
 *  @date       April 2022
 *
 *             Style for the input components
 */

@media screen and (min-device-width: 800px) {
  .inlineinput input,
  .inlineinput select {
    width: 100%;
  }
}

.inlineinput input[type="number"] {
  color: var(--primary-hue-main);
  font-weight: bold;
}

.inlineinput select option {
  color: black;
}

.inlineinput input::placeholder {
  opacity: 1;
  font-size: 0.9rem;
}

.inlineinput input::placeholder,
.inlineinput select:invalid {
  color: var(--content-hue-lighter);
}

.inlineinput label {
  position: relative;
  display: inline-block;
  background-color: white;
  margin: 0 1.25em 0 0.4em;
  padding: 0 0.75em 0 0.75em;
  font-size: 0.7em;
  line-height: 1em;
  top: 0.6em;
  left: 0.2em;
  color: #8a8a8a;
  z-index: 2;
}

select.invalid,
input.invalid {
  border-color: var(--error-hue);
}

/* TODO: Remove when the DCP-Client CSS is refactored */
.inlineinput select:focus,
.inlineinput input:focus {
  box-shadow: none;
}

.inlineinput select:focus-visible {
  border-color: #000;
}
